import React, { useState } from 'react';

export default function CrmSearch({ onSearch, loading }) {
	const [crmRecordId, setCrmRecordId] = useState('');

	const handleSubmit = (e) => {
		e.preventDefault();
		if (crmRecordId.trim()) {
			onSearch(crmRecordId.trim());
		}
	};

	return (
		<form onSubmit={handleSubmit} className="email-search">
			<h2>Credit Check</h2>
			<p>Enter a Zoho CRM Record ID to look up the contact.</p>
			<div className="input-group">
				<input
					type="text"
					value={crmRecordId}
					onChange={(e) => setCrmRecordId(e.target.value)}
					placeholder="Enter CRM Record ID"
					required
					disabled={loading}
				/>
				<button type="submit" disabled={loading || !crmRecordId.trim()}>
					{loading ? 'Searching...' : 'Search'}
				</button>
			</div>
		</form>
	);
}
